import { Trans } from '@lingui/react'
import { string } from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import './ShippingOptionsList.scss'
import { SA_SELLER_ID } from 'shared/consts/checkout'
import { selectShippingOptionAction } from 'shared/store-checkout/duck/orderDraft'
import {
  getSelectedShippingOptionId,
  getShippingOptions,
} from 'shared/store-checkout/duck/shipse'
import Price from 'views/components/atoms/Price'
import InputCheckboxOrRadio from 'views/components/molecules/InputCheckboxOrRadio'

const ShippingOptionsList = ({ sellerId, subOrderId }) => {
  const dispatch = useDispatch()
  let shippingOptions = useSelector(state => getShippingOptions(state))
  shippingOptions = shippingOptions?.sort((a, b) => a.position - b.position)
  const selectedShippingOptionId = useSelector(state =>
    getSelectedShippingOptionId(state, subOrderId)
  )

  // placeholder hardcoded fix for UPPERCASE only carrier names in SHIPSe contract
  const carrierDisplayNames = {
    DHL: 'DHL',
    HERMES: 'Hermes',
    THERMOMED: 'Thermomed',
  }

  const shippingMethodDisplayNames = {
    STANDART: 'Standard',
    EXPRESS: 'Express',
  }

  return (
    <ul className="o-ShippingOptionsList a-list-reset">
      {shippingOptions?.map(shippingOption => {
        const {
          id: shippingOptionId,
          group: carrierName,
          shippingMethod,
          defaultDeliveryTimeMin,
          defaultDeliveryTimeMax,
          shippingCost,
        } = shippingOption
        const carrierDisplayName = carrierDisplayNames[carrierName]
        const shippingMethodDisplayName =
          shippingMethodDisplayNames[shippingMethod]
        const isExpress = shippingOption.shippingMethod === 'EXPRESS'
        return (
          <li
            className="u-padding-large--top a-h4 u-font-weight--bold u-border--top o-ShippingOptionsList__element"
            key={shippingOptionId}
          >
            <InputCheckboxOrRadio
              id={`shippingService-${subOrderId}-${shippingOptionId}`}
              type="radio"
              name={`shippingService-${subOrderId}`}
              value={shippingOption.name}
              defaultChecked={
                selectedShippingOptionId
                  ? shippingOptionId === selectedShippingOptionId
                  : shippingOptionId === shippingOptions[0].id
              }
              onChange={() => {
                dispatch(
                  selectShippingOptionAction({
                    subOrderId,
                    identifier: shippingOptionId,
                    costs: shippingCost,
                  })
                )
              }}
            >
              <div className="o-ShippingOptionsList__shippingCompany l-flex l-flex--distribute-space">
                <div>
                  {sellerId === SA_SELLER_ID ? (
                    <Trans
                      id="checkout.ShippingServiceList.shippingCompany.name"
                      values={{
                        shippingSpeed: isExpress ? 'Express' : 'Standard',
                        serviceName: carrierDisplayName,
                      }}
                    />
                  ) : (
                    <Trans
                      id="checkout.ShippingServiceList.shippingCompany.shippingSpeed"
                      values={{
                        shippingSpeed: shippingMethodDisplayName,
                      }}
                    />
                  )}
                </div>
                <div className="u-color--grey">
                  {shippingCost > 0 ? (
                    <Price amount={shippingCost} />
                  ) : (
                    <Trans id="checkout.ShippingServiceList.shippingCompany.freeDelivery" />
                  )}
                </div>
              </div>
              <div className="o-ShippingOptionsList__deliveryTime u-color--positive">
                {defaultDeliveryTimeMax === '1' ? (
                  <Trans id="checkout.ShippingServiceList.shippingCompany.deliveryTime.oneDay" />
                ) : (
                  <Trans
                    id="checkout.ShippingServiceList.shippingCompany.deliveryTime.multipleDays"
                    values={{
                      deliveryTime: `${defaultDeliveryTimeMin}-${defaultDeliveryTimeMax}`,
                    }}
                  />
                )}
              </div>
            </InputCheckboxOrRadio>
          </li>
        )
      })}

      {sellerId !== SA_SELLER_ID && (
        <li className="o-ShippingOptionsList__element--hint">
          <Trans id="checkout.ShippingServiceList.shippingCompany.shipmentHint" />
        </li>
      )}
    </ul>
  )
}

ShippingOptionsList.propTypes = {
  sellerId: string.isRequired,
  subOrderId: string.isRequired,
}

export default ShippingOptionsList
